import { Box, Button, Stack } from '@mui/material';
import DialogBody from 'components/dialog/DialogBody';
import DialogButtons from 'components/dialog/DialogButtons';
import DialogContent from 'components/dialog/DialogContent';
import DialogTitle from 'components/dialog/DialogTitle';
import { memo } from 'react';

interface IConfirmDialogProps {
  handleClick: () => void;
  contents: string;
  title?: string;
  buttonText: string;
}
function ConfirmDialog({ title = '', contents, handleClick, buttonText }: IConfirmDialogProps): JSX.Element {
  return (
    <DialogContent width={{ desktop: 400 }} height={{ desktop: 'fit-content' }}>
      {title && <DialogTitle hideCloseButton>{title}</DialogTitle>}
      <DialogBody style={{ overflowX: 'hidden', overflowY: 'scroll !important' }}>
        <Box sx={{ fontSize: 18, fontWeight: 700, mb: 3 }}>{contents}</Box>
      </DialogBody>
      <DialogButtons justifyContent="flex-end" marginTop="0px">
        <Stack direction="row" spacing={2} alignContent="center">
          <Button variant="contained" color="primary" onClick={handleClick}>
            {buttonText}
          </Button>
        </Stack>
      </DialogButtons>
    </DialogContent>
  );
}

export default memo(ConfirmDialog);
